/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-proposal-policies';

export const EntityProposalPolicyApi = {
  findForSelect: async (option: FindEntityProposalPolicyForSelectQuery) => {
    let url = `${pathname}/select`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForSelectInChain: async (
    option: FindEntityProposalPolicyForSelectQuery
  ) => {
    let url = `${pathname}/select-in-chain`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDefault: async () => {
    const url = `${pathname}/default`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductProposal: async (id, option: FindOptions) => {
    let url = `${pathname}/find-product-proposal-policy/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: FindOptions) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneWithEntity: async (id: string) => {
    const url = `${pathname}/find-one-with-entity/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProductForInherit: async (id: string) => {
    const url = `${pathname}/find-entity-product-for-inherit/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProductForDuplicate: async (id: string) => {
    const url = `${pathname}/find-entity-product-for-duplicate/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInheritEntityProposalPolicy: async (
    option: FindEntityProposalPolicyForInheritQuery
  ) => {
    let url = `${pathname}/find-inherit-entity-proposal-policy`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForInherit: async (option: FindEntityProposalPolicyForInheritQuery) => {
    let url = `${pathname}/find-for-inherit`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForDuplicate: async (option: FindEntityProposalPolicyForInheritQuery) => {
    let url = `${pathname}/find-for-duplicate`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOneOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    const url = pathname;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (options: CheckDuplicateEntityProposalPolicyQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(options);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  duplicate: async (id: string, body: DuplicateEntityProposalPolicyBody) => {
    const url = `${pathname}/duplicate/${id}`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityProposalPolicyForRetail: async () => {
    const url = `${pathname}/find-entity-proposal-policy-for-retail`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateEntityProposalPolicyForRetail: async (
    body: UpdateEntityProposalPolicyForRetailBody
  ) => {
    const url = `${pathname}/update-entity-proposal-policy-for-retail`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeMultiChainEntityAndPartnerEntityProposalPolicy: async (
    body: RemoveMultiChainEntityAndPartnerEntityProposalPolicy
  ) => {
    const url = `${pathname}/remove-partner-and-chain-entity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMultiChainEntityAndPartnerEntityProposalPolicy: async (
    body: UpdateMultiChainEntityAndPartnerBody
  ) => {
    const url = `${pathname}/update-multi-partner-and-chain-entity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findApplyEntityInEntityProposalPolicy: async (id: string) => {
    const url = `${pathname}/apply-entities/${id}`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindEntityProposalPolicyForInheritQuery {
  name?: string;
  entityID?: string;
  proposalPolicyID?: string;
  isInherit?: boolean;
}

export interface FindEntityProposalPolicyForSelectQuery {
  entityID?: string;
}

export type EntityProposalPolicy = {
  id: string;
  name: string;
  code: string;
  entityID: string;
  isDefault?: boolean;
  totalMember?: number;
  rating?: number;
  status?: number;
  createdAt?: string;
  updatedAt?: string;
  proposalPolicy?: any;
  partners?: any[];
  invitations?: any[];
};

export interface DuplicateEntityProposalPolicyBody {
  name: string;
  chainEntityIDs?: string[];
}

export interface CheckDuplicateEntityProposalPolicyQuery {
  code: string;
  entityID: string;
}

export interface UpdateEntityProposalPolicyForRetailBody {
  entityProposalPolicyID: string;
  entityID?: string;
}

export interface RemoveMultiChainEntityAndPartnerEntityProposalPolicy {
  partnerIDs?: string[];
  entityIDs?: string[];
}

export interface UpdateMultiChainEntityAndPartnerBody {
  partners?: Array<UpdateEntityPolicyBodyItem>;
  entities?: Array<UpdateEntityPolicyBodyItem>;
}

export interface UpdateEntityPolicyBodyItem {
  id: string;
  entityPricePolicyID?: string;
  entityProposalPolicyID?: string;
}
